export const normalizeInAppRoute = (
  targetPath: string,
  currentOrigin: string = window.location.origin
): string | null => {
  if (!targetPath) {
    return null;
  }

  const trimmedTargetPath = targetPath.trim();

  if (!trimmedTargetPath) {
    return null;
  }

  if (trimmedTargetPath.startsWith('/')) {
    return trimmedTargetPath;
  }

  try {
    const parsed = new URL(trimmedTargetPath);
    if (parsed.origin !== currentOrigin && parsed.hostname !== 'localhost') {
      return null;
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
};

export const getNotificationDeepLinkRoute = (
  notificationData: { deepLinkPath?: unknown } | null | undefined,
  currentOrigin?: string
): string | null => {
  if (!notificationData || typeof notificationData.deepLinkPath !== 'string') {
    return null;
  }

  return normalizeInAppRoute(notificationData.deepLinkPath, currentOrigin);
};
